import React from 'react';

export const ArrowDownIcon = ({ size, props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size | 24}
    height={size | 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      className="arrowDown"
      d="M8.14644661,10.1464466 C8.34170876,9.95118446 8.65829124,9.95118446 8.85355339,10.1464466 L12.4989857,13.7981758 L16.1502401,10.1464466 C16.3455022,9.95118446 16.6620847,9.95118446 16.8573469,10.1464466 C17.052609,10.3417088 17.052609,10.6582912 16.8573469,10.8535534 L12.4989857,15.2123894 L8.14644661,10.8535534 C7.95118446,10.6582912 7.95118446,10.3417088 8.14644661,10.1464466 Z"
    />
  </svg>
);
